import { useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import { DashboardBooking } from '@/models';
import { ReportsControllerGetBookingReportV1Params, getSMPBackendAPIAdmin } from '@/proxy';
import { toDashboardBooking } from '@/services';

function getDashboardBookings(params: ReportsControllerGetBookingReportV1Params) {
  return getSMPBackendAPIAdmin().reportsControllerGetBookingReportV1(params);
}

export function useDashboardBookings(params: ReportsControllerGetBookingReportV1Params) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: queryKeys.dashboard.bookings(params),
    queryFn: () => getDashboardBookings(params),
    staleTime: 86400000,
    initialData: () =>
      queryClient.getQueryData<DashboardBooking>(queryKeys.dashboard.bookings(params)),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKeys.dashboard.bookings(params))?.dataUpdatedAt,
    select: (data) => toDashboardBooking(data),
  });
}
